import { Component, OnInit, Input, DoCheck, Optional, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, ControlContainer, FormGroupDirective, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ErrorMassageValidation } from '../../Shared/services/validationErrorMassage.service';
import { InputType } from '../../Shared/Enums/InputType';
import { UtilityService } from '../../Shared/services/UtilityService';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { TextAreaOptions } from '../../Shared/Models/TextAreaOptions';

@Component({
  selector: 'BBSF-TextArea',
  templateUrl: './TextArea.component.html',
  styleUrls: ['./TextArea.component.scss']
})
export class TextAreaComponent implements OnInit {


  static controlContainerstatic = null;
  constructor(private ErrorHandler: ErrorMassageValidation, private controlUtility: ControlUtility, @Optional() private controlContainer: ControlContainer, public TextAreaControlHost: FormGroupDirective) {
    TextAreaComponent.controlContainerstatic = this.controlContainer;
  }
  @Input() group: FormGroup;
  @Input() options: TextAreaOptions;
  @Output() OnChange = new EventEmitter();

  TextAreaFormControl: AbstractControl;
  WordCount: number = 0;
  WordCountArray: number = 0;
  IsShowWordCount: boolean = false;
  markAllAsTouched: boolean = false;
  validationRules = [];
  validationRulesasync = [];

  ngOnInit() {
    UtilityService.isCreatedBefor = false
    this.group.addControl(this.options.Name, new FormControl(''));
    this.TextAreaFormControl = this.group.controls[this.options.Name]; //  new FormControl('',validationRules);

    if (this.options.LabelKey != null && this.options.LabelKey != "")
      this.options.LabelValue = UtilityService.getResourceValue(this.options.LabelKey);

    this.TextAreaFormControl.setValue(this.options.Value);
    if (this.options.CustomValidation.length > 0) {
      let Validations = this.options.CustomValidation
      for (let index = 0; index < Validations.length; index++) {
        const Validation = Validations[index];
        this.validationRules.push(Validation.functionBody);
      }

    }
    if (this.options.MinLength > 0) {
      this.validationRules.push(Validators.minLength(this.options.MinLength));
    }
    if (this.options.MaxLength > 0) {
      this.validationRules.push(Validators.maxLength(this.options.MaxLength));
    }
    if (this.options.IsRequired) {
      this.validationRules.push(Validators.required);
    }
    this.TextAreaFormControl.setValidators(this.validationRules);
    this.TextAreaFormControl.setAsyncValidators(this.validationRulesasync);
    if (this.options.IsDisabled) {
      this.TextAreaFormControl.disable();
    }

    this.TextAreaControlHost.ngSubmit.subscribe((value) => {
      this.group.markAllAsTouched()
      this.markAllAsTouched = true
    })

  }


  ngAfterViewInit(): void {
    this.controlUtility.setAttributeForControl(this.options)
  }

  resetError = () => {
    UtilityService.RemoveGlobalError();
  }

  showGlobalError() {
    this.controlUtility.showGlobalError()
  }

  getErrorValidation(ErrorList) {
    if (this.markAllAsTouched && this.group.invalid) {
      this.showGlobalError()
      this.markAllAsTouched = false
    }
    return this.controlUtility.getErrorValidationMassage(ErrorList, this.group, this.options);
  }
  getInputType(type: number) {
    return this.controlUtility.getInputType(type)
  }

  trimControlValue() {
    let OrignalValue = this.controlUtility.trimControlValue(this.TextAreaFormControl.value);
    this.TextAreaFormControl.patchValue(OrignalValue)
  }

  copyInputMessage(inputElement) {
    this.controlUtility.CopyInputMessage(inputElement)
  }

  onTextChange() {

    if (this.TextAreaFormControl.value == "") {
      this.WordCountArray = 0;
      this.WordCount = 0;
    }

    else {
      this.WordCountArray = this.TextAreaFormControl.value.split(" ").length;
      if (this.WordCountArray > 0) {
        if (this.WordCountArray > this.options.MaxWordCount) {
          this.WordCount = this.options.MaxWordCount;
          this.TextAreaFormControl.setErrors({ "errorMassage": `  Word count must be less then or equal  ${this.options.MaxWordCount}` });
          this.TextAreaFormControl.markAsTouched();
          this.TextAreaFormControl.invalid;
        }
        else {
          this.WordCount = this.WordCountArray;

        }

      }
    }
    this.OnChange.emit(this.TextAreaFormControl.value)

  }

  showWordCount(value: boolean) {
    this.IsShowWordCount = value
  }

  //External Method
  RemoveRequiredValidation = () => {
    this.controlUtility.RemoveRequiredValidation(this.TextAreaFormControl, this.validationRules, this.options)
  }
  //External Method
  AddRequiredValidation = () => {
    this.controlUtility.AddRequiredValidation(this.TextAreaFormControl, this.validationRules, this.options)
  }

  //External Method
  RemoveCustomValidation = (CustomValidation) => {
    this.controlUtility.RemoveCustomValidation(this.TextAreaFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  AddCustomValidation = (CustomValidation) => {
    this.controlUtility.AddCustomValidation(this.TextAreaFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  IsValid = () => {
    this.controlUtility.IsValid(this.TextAreaFormControl)
  }
}


